// European-Portuguese (pt-pt) overlay for the shared UI dictionary (part 1).
// Keys mirror the dictionary tuples; brand names / technical acronyms are
// intentionally omitted so they fall back to their default value.
export const kPtOverlay1: Record<string, string> = {
  _alert: ' alerta',
  _alerts: ' alertas',
  _all_alerts_on_this_page: ' todos os alertas desta página',
  _the_selection: ' a seleção',
  _this_alert: ' este alerta',
  agent: 'Agente',
  agents: 'Agentes',
  alert_level: 'Nível de Alerta',
  alert: 'Alerta',
  alertArchived: 'Arquivada',
  alertCritical: 'Crítica',
  alertCriticalMany: 'Críticas',
  alertInformative: 'Informativa',
  alertInformativeMany: 'Informativas',
  alertNew: 'Nova',
  alertResolved: 'Resolvida',
  alerts_overview: 'Visão Geral dos Alertas',
  alerts: 'Alertas',
  alertSent: 'Enviada',
  alertStill_active: 'Ainda Ativa',
  alertUrgent: 'Urgente',
  alertUrgentMany: 'Urgentes',
  all_alerts_on_this_page: 'Todos os Alertas desta Página',
  always_accept: 'Aceitar Sempre',
  always_reject: 'Recusar Sempre',
  apply: 'Aplicar',
  archive_all: 'Arquivar Tudo',
  archive: 'Arquivar',
  archived: 'Arquivado',
  auto_resolution: 'Resolução auto.',
  bus_terminal: 'Terminal Autocarro',
  bus_client: 'Cliente Autocarro',
  bus_terminals: 'Terminais Autocarro',
  bus_clients: 'Clientes Autocarro',
  bus: 'Autocarro',
  buses: 'Autocarros',
  business: 'Negócios',
  by_default: 'Por Predefinição',
  cancel_filtering: 'Cancelar Filtragem',
  cancel: 'Cancelar',
  check_online: 'Verificação Online',
  child: 'Criança',
  cleaning: 'Limpeza',
  clear_selection: 'Limpar Seleção',
  close: 'Fechar',
  code: 'Código',
  company_code: 'Código da Empresa',
  communication: 'Comunicação',
  contact: 'Contacto',
  contacts: 'Contactos',
  contracts: 'Contratos',
  critical: 'Crítico',
  dashboard: 'Painel de Controlo',
  date: 'Data',
  dateFrom: 'De',
  dateSince: 'Desde',
  dateTo: 'Até',
  default_validation_profile: 'Perfil de Val. Predefinido',
  deselect_all: 'Desmarcar Tudo',
  deselect: 'Desmarcar',
  details: 'Detalhes',
  device_id_range: 'Intervalo de ID de Dispositivo',
  device_id: 'ID de Dispositivo',
  downtime: 'Tempo de Inatividade',
  driver_id: 'ID de Condutor',
  driver_service_id: 'ID de Serviço de Condutor',
  duration: 'Duração',
  elderly: 'Idoso',
  err_: 'Err.',
  fail: 'Falha',
  error: 'Erro',
  failure: 'Falha',
  export: 'Exportar',
  csv_export: 'Exportar CSV',
  find: 'Localizar',
  government: 'Governo',
  group: 'Grupo',
  groups: 'Grupos',
  history: 'Histórico',
  in_service: 'Em Serviço',
  in_stock: 'Em Stock',
  informative: 'Informativo',
  interchange: 'Correspondência',
  invalidation: 'Invalidação',
  last_30_days: 'Últimos 30 dias',
  last_365_days: 'Últimos 365 dias',
  last_7_days: 'Últimos 7 dias',
  level: 'Nível',
  limited: 'Limitado',
  line_number: 'Número da Linha',
  line: 'Linha',
  lines: 'Linhas',
  load: 'Carregamento',
  loads: 'Carregamentos',
  location: 'Localização',
  logs: 'Registos',
  log_out: 'Terminar Sessão',
  log_record: 'Registo',
  log_records: 'Registos',
  logical_id: 'ID Lógico',
  maintenance: 'Manutenção',
  map: 'Mapa',
  mask__base_10_: 'Máscara (Base 10)',
  mathNumber: 'Número',
  max__passengers: 'Máx. Passageiros',
  max_: 'Máx.',
  min_: 'Mín.',
  name: 'Nome',
  navigation_station: 'Estação de Navegação',
  navigation_stations: 'Estações de Navegação',
  navigation: 'Navegação',
  network: 'Rede',
  networks: 'Redes',
  new: 'Novo',
  no_equipment: 'Sem Equipamento',
  no: 'Não',
  normal: 'Normal',
  number: 'Número',
  offer_products: 'Produtos da Oferta',
  offer: 'Oferta',
  offers: 'Ofertas',
  operation: 'Operação',
  operations: 'Operações',
  operator: 'Operador',
  pageFirst: 'Primeira',
  pageNext: 'Seguinte',
  pagePrevious: 'Anterior',
  parameter: 'Parâmetro',
  parameters: 'Parâmetros',
  per_page: 'Por Página',
  period: 'Período',
  physical_id: 'ID Físico',
  pontoons: 'Pontões',
  preset: 'Predefinição',
  presets: 'Predefinições',
  product: 'Produto',
  products: 'Produtos',
  profile: 'Perfil',
  profiles: 'Perfis',
  qr_mode: 'Modo QR',
  reduced_mobility: 'Mobilidade Reduzida',
  registered: 'Registado',
  reloading_id: 'ID de Recarga',
  reset: 'Repor',
  resolve: 'Resolver',
  resolved: 'Resolvido',
  run_id: 'ID de Circulação',
  save: 'Guardar',
  search: 'Pesquisar',
  season_pass: 'Passe',
  security: 'Segurança',
  select_a_bus: 'Selecionar um Autocarro',
  select_a_station: 'Selecionar uma Estação',
  select_all: 'Selecionar Tudo',
  select: 'Selecionar',
  selection: 'Seleção',
  send: 'Enviar',
  sent: 'Enviado',
  service_hours: 'Horas de Serviço',
  setting: 'Definição',
  settings: 'Definições',
  stakeholder: 'Parte Interessada',
  station_name: 'Nome da Estação',
  station_number: 'Número da Estação',
  station_saved: 'Estação Guardada',
  station: 'Estação',
  stations: 'Estações',
  status: 'Estado',
  still_active: 'Ainda Ativo',
  stopped: 'Parado',
  stoppedMany: 'Parados',
  student: 'Estudante',
  subline_id: 'ID de Sublinha',
  success: 'Sucesso',
  technician: 'Técnico',
  terminal_name: 'Nome do Terminal',
  terminal_status: 'Estado do Terminal',
  terminal_removed: 'Terminal Removido',
  terminal: 'Terminal',
  terminals_updated: 'Terminais Atualizados',
  terminals: 'Terminais',
  client_name: 'Nome do Cliente',
  client_status: 'Estado do Cliente',
  client: 'Cliente',
  clients_updated: 'Clientes Atualizados',
  clients: 'Clientes',
  test: 'Teste',
  this_alert: 'Este Alerta',
  today: 'Hoje',
  tomorrow: 'Amanhã',
  transport_mode: 'Modo de Transporte',
  trip: 'Viagem',
  trips: 'Viagens',
  type: 'Tipo',
  unitDay: 'Dia',
  unitDays: 'Dias',
  unitHour: 'Hora',
  unitHours: 'Horas',
  unitH: 'H',
  unitMinute: 'Minuto',
  unitMinutes: 'Minutos',
  unitMin: 'Min',
  unitmm: 'mm',
  unitMonth: 'Mês',
  unitMonths: 'Meses',
  unitM: 'M',
  unitSecond: 'Segundo',
  unitSeconds: 'Segundos',
  unitS: 'S',
  unitYear: 'Ano',
  unitYears: 'Anos',
  unitY: 'A',
  unknown: 'Desconhecido',
  urgent: 'Urgente',
  user: 'Utilizador',
  users: 'Utilizadores',
  validation_profile: 'Perfil de Validação',
  validation: 'Validação',
  validations: 'Validações',
  validity_end: 'Fim de Validade',
  vaporetto_terminal: 'Terminal Navigône',
  vaporetto_terminals: 'Terminais Navigône',
  vaporetto_client: 'Cliente Navigône',
  vaporetto_clients: 'Clientes Navigône',
  vaporetto: 'Metro',
}
